
export default {
  state: {
    documentation: {
      componentName: 'documentList'
    },
    systemData: {
      componentName: 'base-systemnotice'
    },
    docTable: {
      data: []
    }
  },
  mutations: {
    docList(state, data){
      state.docTable = data;
    },
    documentationData(state, data){
      state.documentation = data;
    },
    systemData(state, data){
      state.systemData = data;
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/docStore.js